<div class="relative w-full h-full overflow-hidden">
	<summary-start-page
		class="absolute w-full h-full transition-all duration-1000 ease-in-out"
		[class.-translate-x-full]="currentSlideIndex() > 0"
		[year]="year()"
	></summary-start-page>

	<multiple-vehicles-slide
		class="bg-primary-300"
		icon="robot_one"
		slideTitle="summary.busytime"
		[values]="topVehiclesBusyAbs()"
		[currentSlideIndex]="currentSlideIndex()"
		[startSlideIndex]="1"
	></multiple-vehicles-slide>

	<multiple-vehicles-slide
		class="bg-[#FFEF90]"
		icon="weight"
		slideTitle="summary.weight"
		[values]="topVehiclesWeightAbs()"
		[currentSlideIndex]="currentSlideIndex()"
		[startSlideIndex]="3"
	></multiple-vehicles-slide>

	<multiple-vehicles-slide
		class="bg-[#FFF4B5]"
		icon="x_arrows_up"
		slideTitle="summary.pickups"
		[values]="topVehiclesPickupCnt()"
		[currentSlideIndex]="currentSlideIndex()"
		[startSlideIndex]="5"
	></multiple-vehicles-slide>

	<multiple-vehicles-slide
		class="bg-[#FFFAE0]"
		icon="x_arrows_right"
		slideTitle="summary.distance"
		[values]="topVehiclesDistanceAbs()"
		[currentSlideIndex]="currentSlideIndex()"
		[startSlideIndex]="7"
	></multiple-vehicles-slide>

	<div
		class="absolute flex w-full h-full transition-all duration-1000 ease-in-out"
		[class]="{
			'right-0': currentSlideIndex() < 9,
			'translate-x-full': currentSlideIndex() < 9,
			'left-0': currentSlideIndex() >= 9,
			'-translate-x-full': currentSlideIndex() > 9,
		}"
		id="summary-of-the-year-multiple-vehicles-overview"
	>
		<multiple-vehicles-small-slide
			class="absolute w-1/2 h-1/2 left-0 top-0 bg-primary-300"
			icon="robot_one"
			slideTitle="summary.busytime"
			[values]="topVehiclesBusyAbs()"
		></multiple-vehicles-small-slide>
		<multiple-vehicles-small-slide
			class="absolute w-1/2 h-1/2 right-0 top-0 bg-[#FFEF90]"
			icon="weight"
			slideTitle="summary.weight"
			[values]="topVehiclesWeightAbs()"
		></multiple-vehicles-small-slide>
		<multiple-vehicles-small-slide
			class="absolute w-1/2 h-1/2 bottom-0 left-0 bg-[#FFF4B5]"
			icon="x_arrows_up"
			slideTitle="summary.pickups"
			[values]="topVehiclesPickupCnt()"
		></multiple-vehicles-small-slide>
		<multiple-vehicles-small-slide
			class="absolute w-1/2 h-1/2 bottom-0 right-0 bg-[#FFFAE0]"
			icon="x_arrows_right"
			slideTitle="summary.distance"
			[values]="topVehiclesDistanceAbs()"
		></multiple-vehicles-small-slide>

		<summary-overview-label
			class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 hidden"
			id="summary-of-the-year-multiple-vehicles-overview-label"
			[year]="year()"
		>
		</summary-overview-label>
	</div>

	<summary-download-page
		class="absolute w-full h-full transition-all duration-1000 right-0 ease-in-out"
		[class.translate-x-full]="currentSlideIndex() < totalSlides - 1"
		[year]="year()"
		overviewPageId="summary-of-the-year-multiple-vehicles-overview"
		overviewLabelId="summary-of-the-year-multiple-vehicles-overview-label"
	>
	</summary-download-page>

	<summary-navigation
		class="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
		[numberOfSlides]="totalSlides"
		[(currentSlideIndex)]="currentSlideIndex"
	></summary-navigation>
	<ui-button
		type="link-dark"
		icon="x_cross"
		iconSize="l"
		class="absolute top-8 right-8 z-10"
		[styleClass]="
			currentSlideIndex() === 0 || currentSlideIndex() === totalSlides - 1
				? 'text-white!'
				: 'text-secondary-500!'
		"
		(buttonClicked)="closeSummary()"
	></ui-button>
</div>
